import React, { useState } from 'react'
import { ControlledCustomSelect } from '../../../../Components/formComponents'
import { IStoreState, useAppDispatch, useAppSelector } from '../../../../redux';
import { fetchOutletsListAsync } from '../../../../redux/settings/outlets';

interface IOutletsDropDownProps {
    value: string | null
    onChange: (data: string) => void
    error?: string
}
export const OutletsDropDown: React.FC<IOutletsDropDownProps> = ({
    value,
    onChange,
    error
}) => {
    const {
        data: outletsList,
        loading,
    } = useAppSelector((storeState: IStoreState) => storeState.settings.outlets.outlets_list);
    const dispatch = useAppDispatch();

    const [companiesList, setCompaniesList] = useState<{ label: string, value: string | number }[]>([])

    React.useEffect(() => {
        dispatch(
            fetchOutletsListAsync({
                page: 1,
                rowsPerPage: 1000,
            }),
        );
    }, []);

    React.useEffect(() => {
        const newList = outletsList.map((data) => ({ label: data.outlet_name || "", value: data.outlet_uuid || "" }))
        setCompaniesList(newList)
    }, [outletsList]);

    return (
        <ControlledCustomSelect
            label="Select Outlet"
            options={companiesList}
            value={value}
            onChange={(evt) => onChange(evt.target.value as string)}
            sx={{ minWidth: 120 }}
            fullWidth size="small"
            error={error}
        />
    )
}
